import React, {useContext, useEffect} from 'react'
import {Checkbox, FormControlLabel, FormControl, InputLabel, MenuItem} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import Select from '../../ReservationComponents/Select'
import currencyOptions from './CurrencyOptions.json'
import {ReservationConfigurationContext} from '../../../context/ReservationConfiguration'
import {useParams} from 'react-router'

const FCurrencyField = ({data, onChange = (e, key, value) => {}}) => {
  const {additionalFieldValues, getAdditionalFieldValues} = useContext(
    ReservationConfigurationContext
  )
  const {group_id} = useParams()
  useEffect(() => {
    getAdditionalFieldValues(group_id, [], false, false, true)
  }, [group_id, getAdditionalFieldValues])

  return (
    <>
      {/* <Select
          labelId="1"
          id=""
          value={data}
          label="Currency"
          onChange={onChange}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            
          }}
        >
          {currencyOptions.map(opt => {
            return <MenuItem value={opt.name}>{`${opt.name} - ${opt.symbol}`}</MenuItem>
          })}
        </Select> */}
      <Select
        label="Currency"
        value={data.currency_id}
        onChange={(e, value) => onChange(e, 'currency_id', value)}
        options={additionalFieldValues.data.data?.currency_items?.map(opt => {
          return {label: `${opt.name} - ${opt.symbol}`, value: opt.id}
        })}
        renderSelected={(options, value) => options.find(o => o.value === value)?.label}
        renderOption={v => v.label}
        returnValue={v => v.value}
      />
      <br />
      <FormControlLabel
        style={{marginBottom: 0}}
        control={
          <Checkbox
            onClick={e => onChange(e, 'allow_negative', !(data?.allow_negative || false))}
            size="small"
            checkedIcon={<CheckCircleIcon style={{color: '#3473ff'}} />}
            checked={data?.allow_negative || false}
            name="required"
          />
        }
        label="Allow negative"
      />
    </>
  )
}

export default FCurrencyField
